import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { sessionChargeApi } from './session-charge.api';

export const queryKeys = {
    all: ['session-charge'] as const,
    lists: () => [...queryKeys.all, 'list'] as const,
    list: (clientId: string) => [...queryKeys.lists(), clientId] as const,
    balances: () => [...queryKeys.all, 'balance'] as const,
    balance: (clientId: string) => [...queryKeys.balances(), clientId] as const,
    unpaidLists: () => [...queryKeys.all, 'unpaid'] as const,
    unpaidList: (clientId: string) => [...queryKeys.unpaidLists(), clientId] as const,
};

export function sessionChargeListOptions(clientId: string) {
    return infiniteQueryOptions({
        queryKey: queryKeys.list(clientId),
        queryFn: ({ pageParam, signal }) =>
            sessionChargeApi.getList({ clientId, cursor: pageParam, pageSize: 50 }, signal),
        initialPageParam: null as string | null,
        getNextPageParam: (lastPage) => lastPage.nextCursor,
    });
}

export function clientBalanceOptions(clientId: string) {
    return queryOptions({
        queryKey: queryKeys.balance(clientId),
        queryFn: ({ signal }) => sessionChargeApi.getBalance(clientId, signal),
    });
}

export function unpaidSessionChargeListOptions(clientId: string) {
    return queryOptions({
        queryKey: queryKeys.unpaidList(clientId),
        queryFn: ({ signal }) => sessionChargeApi.getUnpaidList(clientId, signal),
    });
}
